"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderForm = OrderForm;
var react_1 = __importStar(require("react"));
var row_ctx_1 = require("../contexts/row_ctx");
var api_1 = require("../api");
var modal_1 = require("../modal");
var react_toastify_1 = require("react-toastify");
function OrderForm() {
    var _this = this;
    var closeModal = (0, modal_1.useModalClose)();
    var _a = (0, react_1.useContext)(row_ctx_1.RowContext), localRecord = _a.localRecord, updateRecord = _a.updateRecord;
    var _b = (0, react_1.useState)(__assign({}, localRecord)), formRecord = _b[0], setFormRecord = _b[1];
    var _c = (0, react_1.useState)({}), modifiedOrderProps = _c[0], setModifiedOrderProps = _c[1];
    var _d = (0, react_1.useState)([""]), hospitals = _d[0], setHospitals = _d[1];
    var _e = (0, react_1.useState)([]), checkIds = _e[0], setCheckIds = _e[1];
    var prevHospitalsRef = (0, react_1.useRef)(false);
    var prevTjIdRef = (0, react_1.useRef)("");
    if (localRecord === null) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    (0, react_1.useEffect)(function () {
        if (!prevHospitalsRef.current) {
            loadHospitals();
            prevHospitalsRef.current = true;
        }
    }, []);
    (0, react_1.useEffect)(function () {
        if ((formRecord === null || formRecord === void 0 ? void 0 : formRecord.tj_id) === prevTjIdRef.current) {
            return;
        }
        if (formRecord === null || formRecord === void 0 ? void 0 : formRecord.tj_id) {
            loadCheckIds();
        }
        else {
            setFormRecord(function (prev) { return (__assign(__assign({}, prev), { check_id: "" })); });
            setCheckIds([]);
        }
        prevTjIdRef.current = formRecord === null || formRecord === void 0 ? void 0 : formRecord.tj_id;
    }, [formRecord === null || formRecord === void 0 ? void 0 : formRecord.tj_id]);
    var loadHospitals = function () { return __awaiter(_this, void 0, void 0, function () {
        var hospitalList, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, api_1.getHospitals)()];
                case 1:
                    hospitalList = (_a.sent()).map(function (hospital, index) { return hospital.hospital; }) || [];
                    setHospitals(__spreadArray([[""]], hospitalList, true));
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("Error loading hospitals:", error_1);
                    react_toastify_1.toast.error("加载送检单位失败", api_1.toastOptions);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var loadCheckIds = function () { return __awaiter(_this, void 0, void 0, function () {
        var checkIdList_1, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(formRecord === null || formRecord === void 0 ? void 0 : formRecord.tj_id)) {
                        react_toastify_1.toast.info("请填写体检ID", api_1.toastOptions);
                        return [2 /*return*/];
                    }
                    if ((formRecord === null || formRecord === void 0 ? void 0 : formRecord.tj_id) === prevTjIdRef.current) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, api_1.getCheckIds)(formRecord.tj_id, formRecord.hospital)];
                case 2:
                    checkIdList_1 = (_a.sent()).map(function (item) { return [item["checkid"], item["mc"]]; }) || [];
                    if (checkIdList_1.length > 1) {
                        setCheckIds(__spreadArray([["", ""]], checkIdList_1, true));
                    }
                    else if (checkIdList_1.length == 1) {
                        setCheckIds(checkIdList_1);
                        if (checkIdList_1[0][0] !== formRecord.check_id) {
                            setModifiedOrderProps(function (prev) { return (__assign(__assign({}, prev), { check_id: checkIdList_1[0][0] })); });
                        }
                    }
                    else {
                        setModifiedOrderProps(function (prev) { return (__assign(__assign({}, prev), { check_id: "" })); });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.error("Error loading checkIds:", error_2);
                    react_toastify_1.toast.error("加载项目ID失败", api_1.toastOptions);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (e) {
        var _a, _b;
        var _c = e.target, name = _c.name, value = _c.value;
        setFormRecord(__assign(__assign({}, formRecord), (_a = {}, _a[name] = value, _a)));
        setModifiedOrderProps(__assign(__assign({}, modifiedOrderProps), (_b = {}, _b[name] = value, _b)));
        modifiedOrderProps[name] = value;
    };
    var handleSubmit = function (e) {
        console.log(localRecord.id, "handleSubmit");
        e.preventDefault();
        (0, api_1.modifyOrder)(__assign(__assign({}, modifiedOrderProps), { id: localRecord.id }))
            .then(function (updatedData) {
            updateRecord(modifiedOrderProps);
            updateRecord({
                report_id: updatedData.report_id,
                report_date: updatedData.report_date,
                uploaded_at: updatedData.uploaded_at,
                uploaded_results: updatedData.uploaded_results,
            });
            closeModal();
        })
            .catch(console.error);
        console.log("Submitted data:", localRecord);
        // you can send formData to backend here
    };
    return (react_1.default.createElement("form", { onSubmit: handleSubmit, className: "zmsk-form orderform" },
        react_1.default.createElement("div", { className: "tabular" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null,
                    react_1.default.createElement("span", { className: "redAsterisk" }, "*"),
                    "\u8BA2\u5355\u7F16\u53F7",
                    react_1.default.createElement("input", { type: "text", name: "order_id", value: formRecord.order_id, readOnly: true }))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null,
                    react_1.default.createElement("span", { className: "redAsterisk" }, "*"),
                    "\u6837\u672C\u7F16\u53F7",
                    react_1.default.createElement("input", { type: "text", name: "sample_id", value: formRecord.sample_id, onChange: handleChange }))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null,
                    "\u9001\u68C0\u5355\u4F4D",
                    react_1.default.createElement("select", { name: "hospital", value: formRecord.hospital, onChange: handleChange }, hospitals.map(function (hospital, index) { return (react_1.default.createElement("option", { key: index, value: hospital }, hospital)); })))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null,
                    react_1.default.createElement("span", { className: "redAsterisk" }, "*"),
                    "\u60A3\u8005\u7F16\u53F7",
                    react_1.default.createElement("input", { type: "text", name: "patient_id", value: formRecord.patient_id, onChange: handleChange }))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null,
                    "\u9001\u68C0\u533B\u751F",
                    react_1.default.createElement("input", { type: "text", name: "doctor", value: formRecord.doctor, onChange: handleChange }))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null,
                    "\u60A3\u8005\u59D3\u540D",
                    react_1.default.createElement("input", { type: "text", name: "patient_name", value: formRecord.patient_name, onChange: handleChange }))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null,
                    react_1.default.createElement("span", { className: "redAsterisk" }, "*"),
                    "\u68C0\u6D4B\u9879\u76EE",
                    react_1.default.createElement("input", { type: "text", name: "product_name", value: formRecord.product_name, readOnly: true }))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null,
                    "\u60A3\u8005\u6027\u522B",
                    react_1.default.createElement("select", { name: "patient_gender", value: formRecord.patient_gender, onChange: handleChange },
                        react_1.default.createElement("option", { value: "\u7537" }, "\u7537"),
                        react_1.default.createElement("option", { value: "\u5973" }, "\u5973")))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null,
                    "\u6837\u672C\u7C7B\u578B",
                    react_1.default.createElement("select", { name: "sample_type", value: formRecord.sample_type, onChange: handleChange },
                        react_1.default.createElement("option", { value: "" }),
                        react_1.default.createElement("option", { value: "\u8840\u6DB2" }, "\u8840\u6DB2"),
                        react_1.default.createElement("option", { value: "\u751F\u6B96\u9053\u8131\u843D\u7EC6\u80DE" }, "\u751F\u6B96\u9053\u8131\u843D\u7EC6\u80DE")))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null,
                    "\u60A3\u8005\u5E74\u9F84",
                    react_1.default.createElement("input", { type: "text", name: "patient_age", value: formRecord.patient_age, onChange: handleChange }))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null,
                    "\u91C7\u6837\u65E5\u671F",
                    react_1.default.createElement("input", { type: "date", name: "sampling_date", value: formRecord.sampling_date, onChange: handleChange }))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null,
                    "\u8054\u7CFB\u7535\u8BDD",
                    react_1.default.createElement("input", { type: "tel", name: "phone", value: formRecord.phone, onChange: handleChange }))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null,
                    "\u63A5\u6536\u65E5\u671F",
                    react_1.default.createElement("input", { type: "date", name: "receipt_date", value: formRecord.receipt_date, onChange: handleChange }))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null,
                    "\u8EAB\u4EFD\u8BC1",
                    react_1.default.createElement("input", { type: "text", name: "resident_id", value: formRecord.resident_id, onChange: handleChange }))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null,
                    "\u68C0\u9A8C\u65E5\u671F",
                    react_1.default.createElement("input", { type: "date", name: "test_date", value: formRecord.test_date, onChange: handleChange }))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null,
                    react_1.default.createElement("span", { className: "redAsterisk" }, "*"),
                    "\u4F53\u68C0ID",
                    react_1.default.createElement("input", { type: "text", name: "tj_id", value: formRecord.tj_id, onChange: handleChange }))),
            react_1.default.createElement("div", null),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null,
                    react_1.default.createElement("span", { className: "redAsterisk" }, "*"),
                    "\u9879\u76EEID",
                    react_1.default.createElement("select", { name: "check_id", value: formRecord.check_id, onChange: handleChange, onFocus: loadCheckIds }, checkIds.map(function (_a) {
                        var checkId = _a[0], mc = _a[1];
                        return (react_1.default.createElement("option", { key: checkId, value: checkId },
                            checkId,
                            " ",
                            mc));
                    }))))),
        react_1.default.createElement("div", { className: "foot-button-group" },
            react_1.default.createElement("button", { type: "button", className: "zmsk-button", onClick: closeModal }, "\u53D6\u6D88"),
            react_1.default.createElement("button", { type: "submit", className: "zmsk-button" }, "\u63D0\u4EA4"))));
}
